import type { GoalId } from "@components/OnboardingWizard/types";
import type { OnboardingV3GoalType } from "./onboardingV3Types";

/** PRD goalId → API goalType（V3.0.6 七态）。 */
export const GOAL_ID_TO_TYPE: Record<GoalId | "runway", OnboardingV3GoalType> =
  {
    "money-leak": "spending",
    "idle-cash": "idlecash",
    "portfolio-risk": "invest",
    "debt-free": "debt",
    million: "million",
    home: "home",
    retirement: "retirement",
    runway: "emergency",
  };

/**
 * PRD goalId → API goalType（V3.0.6 七态）。
 * 验收 P1-3：未知 id 返回 null（状态异常不伪装成用户选择了百万目标）；
 * 未选题（空串）同样返回 null，由调用方 fail-fast 或阻断。
 */
export const mapGoalIdToGoalType = (
  goalId: string,
): OnboardingV3GoalType | null => {
  const mapped = GOAL_ID_TO_TYPE[goalId.trim() as GoalId | "runway"];
  return mapped ?? null;
};
